<script>
  /* eslint-disable new-cap */

import Layout from '@layouts/primary'
import { vehicleMethods, serviceTypeMethods, depotMethods, attributeMethods, binMethods } from '@state/helpers'
import ListLoading from '../../components/loading'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'Vehicles',
    meta: [{ name: 'description', content: 'Vehicles' }],
  },
  components: { Layout, ListLoading },
  data() {
    return {
      search: '',
      loadingData: true,
      headers: [
        { text: 'Vehicle Id', value: 'vehicle_id' },
        { text: 'Number Plate', value: 'number_plate' },
        { text: 'Capacity', value: 'capacity' },
        { text: 'Status', value: 'status' },
        { text: 'Registration Expiry', value: 'dateSeconds' },
        { text: 'Actions', value: 'name', sortable: false },
      ],
      vehicles: [],
      binSelectItems: [],  // Type {value, text}[]
      selectedBins: [],
      depotSelectItems: [],  // Type {value, text}[]
      selectedDepot: null,
      newVehicle: {
        numberPlate: null,
        capacity: null,
      },
      dictionary: {
        attributes: {
          email: 'E-mail Address',
          // custom attributes
        },
        custom: {
          name: {
            required: () => 'Name can not be empty',
            max: 'The name field may not be greater than 10 characters',
            // custom messages
          },
          select: {
            required: 'Select field is required',
          },
        },
      },
      addVehicle: false,
    }
  },
  mounted() {
    let moment = require('moment');
    this.$validator.localize('en', this.dictionary)
    this.getVehicles().then(response => {
      let obj = this.$store.state.vehicles.objects
      for (let v in obj) {

        // Create a copy of the object to update it
        let formattedObj = {
          ...obj
        }

        if(formattedObj[v].active){
          formattedObj[v].status = "Active"
        } else {
          formattedObj[v].status = "Inactive"
        }
        let newArray = Object.assign({}, formattedObj)

        newArray[v].expiry_formatted = moment.unix(newArray[v].vehicle_registration_expiry/1000).format('DD/MM/YYYY');
        newArray[v].dateSeconds = moment.unix(newArray[v].vehicle_registration_expiry/1000).valueOf()

        this.vehicles.push(newArray[v])
      }

      this.loadingData=false
    // eslint-disable-next-line handle-callback-err
    }).catch(error => {
      this.loadingData=false
    })
    this.getBins().then(response => {
      let obj = this.$store.state.bins.objects
      for (let v in obj) {
        this.binSelectItems.push({
          value: obj[v].id,
          text: obj[v].itemcode
        })
      }

      this.loadingData=false
    // eslint-disable-next-line handle-callback-err
    }).catch(error => {
      this.loadingData=false
    })

    this.loadingData=true
    this.getDepots().then(response => {
      let obj = this.$store.state.depots.objects
      for (let v in obj) {
        this.depotSelectItems.push({
          value: obj[v].id,
          text: `${obj[v].address}, ${obj[v].suburb}, ${obj[v].postcode}`
        })
      }
    })

  },
  methods: {
    ...vehicleMethods, ...serviceTypeMethods,...depotMethods,...attributeMethods, ...binMethods,
    observerClean (obj) {
      return Object.keys(obj).reduce(
        (res, e) => Object.assign(res, { [e]: obj[e] }),
        {}
      )
    },
    async submit() {
      await this.$validator.validateAll().then((response) => {
        // console.log(response)
        if(response){
          let attributes = [];
          // console.log(this.newVehicle.attributes)
          const getKeyByValue = (obj, value) =>
            Object.keys(obj).find(key => obj[key] === value);
          for (let i in this.newVehicle.attributes){
            attributes.push(getKeyByValue(this.attributesDict,this.newVehicle.attributes[i]))
          }
          // console.log(this.attributesDesc)

          this.createVehicle({
            numberPlate: this.newVehicle.numberPlate,
            capacity: parseFloat(this.newVehicle.capacity),
            binIds: this.selectedBins,
            depotId: this.selectedDepot,
            regoExpiry: this.newVehicle.regoExpiry
          }).then( d => {
            // When first adding a vehicle we need to create a Default checklist
            this.createVehicleCheckList({
              username: "mechanic",
              numberPlate: this.newVehicle.numberPlate,
              lights: true,
              tyres: true,
              indicators: true,
              mileage: 0
            });
            location.reload()
          })
        }
      })
    },
    clear() {
      this.newVehicle = {}
      this.selectedStatus = true
      this.selectedBins = []
      this.selectedDepot = null
      this.$validator.reset()
      this.addVehicle = false
    },
    changeRoute(r) {
      this.$router.push(r)
    },
  },
}
</script>

<template>
  <Layout>
    <VContainer>
      <div class="">
        <h2 :class="$style.routeHeader">
          Vehicles
        </h2>
        <ListLoading :display="loadingData" />
        <VBtn
          v-if="!loadingData"
          slot="activator"
          :class="$style.addButton"
          color="blue"
          @click="addVehicle = !addVehicle"
        >
          + ADD VEHICLE
        </VBtn>
      </div>

      <VLayout style="width: 100%">

        <VFlex
          xs0
          sm12
        />
        <VFlex
          xs12
          md5
        >
          <VTextField
            v-if="!loadingData"
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          />
        </VFlex>
      </VLayout>

      <VDataTable
        v-if="!loadingData"
        :headers="headers"
        :items="vehicles"
        :search="search"
        rows-per-page-text=""
        :rows-per-page-items="[10]"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <td class="text-xs-left">
            {{ props.item.id }}
          </td>
          <td class="text-xs-left">
            {{ props.item.number_plate }}
          </td>
          <td class="text-xs-left">
            {{ props.item.capacity }}
          </td>
          <td class="text-xs-left">
            {{ props.item.status }}
          </td>
          <td class="text-xs-left">
            {{ props.item.expiry_formatted }}
          </td>

          <td class="justify-center px-0">
            <VBtn
              slot="activator"
              style="display: block; position:relative; margin: 0 auto"
              color="blue"
              @click.native="changeRoute({name: 'view-vehicle', params: {id: props.item.id}})"
            >
              View
            </VBtn>
          </td>
        </template>
      </VDataTable>
    </VContainer>

    <!-- ADD Vehicle MODAL -->
    <VLayout
      row
      justify-center
    >
      <VDialog
        v-model="addVehicle"
        persistent
        max-width="500px"
        scrollable
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <h2>Add Vehicle</h2>
              <VLayout wrap>

                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newVehicle.numberPlate"
                    v-validate="'required'"
                    label="Number Plate"
                    required
                    :error-messages="errors.collect('number plate')"
                    data-vv-name="number plate"
                  />
                </VFlex>

                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newVehicle.capacity"
                    v-validate="'required'"
                    label="Capacity"
                    required
                    :error-messages="errors.collect('capacity')"
                    data-vv-name="capacity"
                    type="number"
                  />
                </VFlex>

                <VFlex
                  xs12
                  sm12
                >
                  <VTextField
                    v-model="newVehicle.regoExpiry"
                    v-validate="'required'"
                    label="Registration Expiry"
                    required
                    :error-messages="errors.collect('regoExpiry')"
                    data-vv-name="regoExpiry"
                    type="date"
                  />
                </VFlex>
                <VFlex
                  xs12
                  sm12
                >
                  <VSelect
                    v-model="selectedBins"
                    v-validate="'required'"
                    :error-messages="errors.collect('bin_ids')"
                    data-vv-name="bin_ids"
                    :items="binSelectItems"
                    :menu-props="{ absolute: true }"
                    label="Bin Types"
                    multiple
                    chips
                    attach
                  />
                </VFlex>

                <VFlex
                  xs12
                  sm12
                >
                  <VSelect
                    v-model="selectedDepot"
                    v-validate="'required'"
                    :error-messages="errors.collect('depot')"
                    data-vv-name="depot"
                    :items="depotSelectItems"
                    :menu-props="{ absolute: true }"
                    label="Depot"
                    chips
                    attach
                  />
                </VFlex>
                <VSpacer />
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    outline
                    @click.native="clear()"
                  >
                    Close
                  </VBtn>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    @click.native="submit()"
                  >
                    Save
                  </VBtn>
                </VFlex>
              </VLayout>
            </VContainer>
          </VCardText>
        </VCard>
      </VDialog>
    </VLayout>

  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.routeHeader {
  display: inline-block;
}

.addButton {
  display: inline-block;
  float: right;
}
</style>
